import type { UserRole } from 'chery-contracts';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { cn } from '../../lib/cn';
import { useI18nTranslation } from '../../lib/use-i18n-translation';

export interface SectionTab {
  to: string;
  labelKey: string;
  /** Exact match, for a section's index tab (`/board` must not light up on `/board/products`). */
  end?: boolean;
  roles?: readonly UserRole[];
}

export interface SectionTabsProps {
  tabs: readonly SectionTab[];
}

/** The tab row of a multi-page section (Setup: KPIs · Targets · Board bindings; Board: its four pages). */
export const SectionTabs = ({ tabs }: SectionTabsProps) => {
  const { t } = useI18nTranslation();
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <nav className="app-shell-chrome flex gap-1 border-b border-border">
        {tabs
          .filter((tab) => !tab.roles || (user && tab.roles.includes(user.role)))
          .map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                  isActive ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground',
                )
              }
            >
              {t(tab.labelKey)}
            </NavLink>
          ))}
      </nav>
      <Outlet />
    </div>
  );
};
